export default "__VITE_ASSET__CLz1kU5I__"